
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone, } from '@fortawesome/fontawesome-svg-core/import.macro';
import { useTranslation } from 'react-i18next';

function WidgetTools(props) {
    const { t } = useTranslation();
    return (
        <>
            {
                (props.toggleSettings !== null) &&
                <OverlayTrigger
                    placement="bottom"
                    delay={{ show: 250, hide: 400 }}
                    overlay={<Tooltip style={{ position: "fixed" }}>
                        {t("config")}
                    </Tooltip>}>
                    <button type="button" className="btn btn-sm btn-icon btn-color-primary btn-active-light-primary" onClick={props.toggleSettings} >
                        <FontAwesomeIcon icon={duotone("grid-2")} />
                    </button>
                </OverlayTrigger>
            }
            
            <OverlayTrigger
                placement="bottom"
                delay={{ show: 250, hide: 400 }}
                overlay={<Tooltip style={{ position: "fixed" }}>
                    {t("close")}
                </Tooltip>}>
                <button type="button" className="btn btn-sm btn-icon btn-color-primary btn-active-light-primary" onClick={props.closeWidget} >
                    <FontAwesomeIcon size="lg" icon={duotone("circle-xmark")} />
                </button>
            </OverlayTrigger>
        </>
    )
}

export default WidgetTools;